export const form = {
  formCopyLink: 'Copy link',
  formLinkCopied: 'Link copied!'
}
